import { render } from "./Arena.vue?vue&type=template&id=2f7526d6"
import script from "./Arena.vue?vue&type=script&lang=js"
export * from "./Arena.vue?vue&type=script&lang=js"
script.render = render

export default script